import {defineStore} from "pinia";
export const bincardStore = defineStore("bincardStore", {
    state: () =>
        ({
            loading: false as boolean,
            pagination: {
                per_page: 0,
                current_page: 1,
                last_page: 0,
            },
            materiales: [],
            materialesListado: [],
            grupoMaterial: [],
            partidaGasto: [],
            showDialogSancion: false as boolean,
            material: [],
            unidad: [],
            bincard: [],
            sumIngresos: [],
            sumSalidas: [],
            saldoInicial: [],
        }),
});